import { GetSiteVisitsParams, SiteVisitsActions, SiteVisitsType, siteVisitsTypes } from "./types"

const actions = {
  getSiteVisits: (
    payload: Partial<GetSiteVisitsParams>,
    start?: number,
    limit?: number,
    callback?: (succ: boolean) => void
  ): SiteVisitsActions => ({
    type: siteVisitsTypes.GET_SITE_VISITS,
    payload,
    start,
    limit,
    callback
  }),
  cancelSiteVisit: (
    payload: {
      siteVisitId: string
    },
    callback?: (succ: boolean) => void
  ): SiteVisitsActions => ({
    type: siteVisitsTypes.CANCEL_SITE_VISIT,
    payload,
    callback
  }),
  setSiteVisits: (payload: SiteVisitsType): SiteVisitsActions => ({
    type: siteVisitsTypes.SET_SITE_VISITS,
    payload
  }),
}

export default actions
